import axios from 'axios';
import BaseApi from './base-api';

class AudioTranscriptionsApi extends BaseApi {
  createTranscription(projectId, audioBlob, fileExtension = 'wav') {
    const formData = new FormData();
    formData.append(
      'audio_transcription[audio]',
      audioBlob,
      `recording.${fileExtension}`
    );

    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/audio_transcriptions`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((response) => {
        return {
          ok: true,
          transcription: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors:
            error.response && error.response.data && error.response.data.errors
              ? error.response.data.errors
              : ['Failed to upload audio for transcription'],
        };
      });
  }

  getTranscription(projectId, transcriptionId) {
    return axios
      .get(
        `${this.baseUrl}/projects/${projectId}/audio_transcriptions/${transcriptionId}`
      )
      .then((response) => {
        return {
          ok: true,
          transcription: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors:
            error.response && error.response.data && error.response.data.errors
              ? error.response.data.errors
              : ['Failed to get transcription'],
        };
      });
  }

  getTranscriptionStatus(projectId, transcriptionId) {
    return axios
      .get(
        `${this.baseUrl}/projects/${projectId}/audio_transcriptions/${transcriptionId}/status`
      )
      .then((response) => {
        return {
          ok: true,
          status: response.data.status,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors:
            error.response && error.response.data && error.response.data.errors
              ? error.response.data.errors
              : ['Failed to get transcription status'],
        };
      });
  }
}

export default new AudioTranscriptionsApi();
